module.exports = __webpack_public_path__ + "img/big-sku-icon.7b21be0.png";